/* storybook-check-ignore */
import * as React from 'react';

import { Box, Divider, Flex, Link, Text } from '@opendoor/bricks/core';
import { Modal } from '@opendoor/bricks/complex';
import NextImage from 'next/image';
import { imgixLoader } from 'helpers/imgixUrl';
import { Address } from 'declarations/exclusives/address';
import { ThemedLite } from '@opendoor/bricks/theme/ODThemeLite';
import { exclusives } from '@opendoor/bricks/theme';

const TourModal: React.FC<{
  isOpen?: boolean;
  onRequestClose?: () => void;
  address?: Address;
  mapLink?: string;
}> = (props) => {
  return (
    <Modal
      analyticsName="cosmos-exclusives-tour-modal"
      isOpen={props.isOpen ?? false}
      onRequestClose={props.onRequestClose}
      hasPadding={false}
      aria-label=""
      headerProps={{
        leftComponent: (
          <ThemedLite theme={exclusives}>
            <Box pl="6px" pt="10px" flexShrink={0} flexGrow={1} maxWidth="100%">
              <NextImage
                loader={imgixLoader}
                width={60}
                height={60}
                src="2023-02-1677598167490-97469.png"
              />
              <Text color="brand50" size="s3" fontWeight="bold">
                Self tour instantly
              </Text>
              <Text>
                You can self tour this home any day from <strong>8AM to 8PM</strong>
              </Text>
            </Box>
          </ThemedLite>
        ),
      }}
    >
      <style
        dangerouslySetInnerHTML={{
          __html: `
          #modal-close-button {
            stroke: white !important;
            box-shadow: none !important;
          }
          .ReactModal__Content > div:first-child > div {
            align-items: flex-start !important;
          }
      `,
        }}
      />
      <Box px="2rem" pb="2rem">
        <Divider pb={6} />
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          borderRadius="roundedSquare"
        >
          <Text fontSize="s2" fontWeight="bold" fontFamily="sans" margin="0">
            How to tour
          </Text>
          <Text fontSize="s1" fontFamily="sans" pt="14px">
            The safety of our visitors is important to us. We need to verify the identity of
            everyone who tours.
          </Text>
          <Box
            display="flex"
            justifyContent="space-between"
            flexWrap="wrap"
            style={{ gap: '1rem' }}
          >
            <ol style={{ paddingInlineStart: '20px', width: '100%' }}>
              <li>
                <Text>Show up and follow the instructions on the door.</Text>
                <Flex
                  border="1px solid #D9D9D9"
                  px="4"
                  py="5"
                  borderRadius="roundedSquare"
                  my="4"
                  justifyContent="space-between"
                >
                  <Text fontWeight="bold">
                    {props.address?.street}, {props.address?.city}, {props.address?.state}{' '}
                    {props.address?.postal_code}
                  </Text>
                  {props.mapLink && (
                    <Link
                      aria-label={null}
                      analyticsName="cosmos-exclusives-tour-modal-map-link"
                      href={props.mapLink}
                      target="_blank"
                      rel="noffolow noopener noreferrer"
                    >
                      Open
                    </Link>
                  )}
                </Flex>
              </li>
              <li>
                Call{' '}
                <Link
                  aria-label={null}
                  analyticsName="cosmos-exclusives-tour-modal-phone-button"
                  href="tel:(855) 476-0049"
                >
                  (855) 476-0049
                </Link>{' '}
                or verify your identity online.
              </li>
              <li>After we verify, our team will remotely unlock the home for you.</li>
            </ol>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default TourModal;
